import { Component, EventEmitter, Output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { Observable, take } from 'rxjs';

import { ModalButtons } from '@fcom/ui-components';
import { CmsArticle } from '@fcom/core-api/interfaces';
import { FragmentService } from '@fcom/common/services';

@Component({
  selector: 'fin-korea-notification',
  templateUrl: './korea-notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class KoreaNotificationComponent {
  public readonly ModalButtons: typeof ModalButtons = ModalButtons;
  public readonly useOfPersonalInformation$: Observable<CmsArticle>;
  public readonly overseasTransferOfPersonalInfo$: Observable<CmsArticle>;
  public readonly form: UntypedFormGroup;
  public readonly dataTestId: string;

  modalOpen = false;

  @Output()
  confirmed: EventEmitter<void> = new EventEmitter();

  @Output()
  close: EventEmitter<void> = new EventEmitter();

  constructor(
    private fragmentService: FragmentService,
    private formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.useOfPersonalInformation$ = this.fragmentService
      .getFragment<CmsArticle>('koreanPaxInfoNotification.useOfPersonalInformation.url')
      .pipe(take(1));

    this.overseasTransferOfPersonalInfo$ = this.fragmentService
      .getFragment<CmsArticle>('koreanPaxInfoNotification.overseasTransferOfPersonalInfo.url')
      .pipe(take(1));

    this.form = this.formBuilder.group({
      useOfPersonalInformation: [false, Validators.requiredTrue],
      overseasTransferOfPersonalInfo: [false, Validators.requiredTrue],
    });
  }

  openModal(): void {
    this.modalOpen = true;
    this.cdr.markForCheck();
  }
}
